document.addEventListener("DOMContentLoaded", function () {
    ps_share_btn();
    managingJobsDesctiptionATags()
});
function ps_share_btn() {
    const buttons = document.querySelectorAll('.job-share-btn');
    buttons.forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            const currentUrl = window.location.href;
            if (navigator.share) {
                navigator.share({
                    title: document.title,
                    url: currentUrl
                })
                    .then(() => console.log('✅ Share successful!'))
                    .catch(error => console.error(error));
            } else {
                alert(`Sharing is not supported in this browser. Copy this link: \n${currentUrl}`);
            }
        });
    });
}

function managingJobsDesctiptionATags() {
    let descriptionTags = document.querySelectorAll(".single-jobs .job_detail_description");
  
    if (descriptionTags.length > 0) {
      descriptionTags.forEach(selectedTag => {
        const pTags = selectedTag.querySelectorAll("p");
        pTags.forEach(p => {
          const onlyHasATags = Array.from(p.childNodes).every(node => {
            return (
              (node.nodeType === 1 && node.tagName.toLowerCase() === 'a') || 
              (node.nodeType === 3 && node.textContent.trim() === "")
            );
          });
  
          if (onlyHasATags) {
            const links = p.querySelectorAll("a");
            links.forEach(link => link.classList.add("jobs_desc_button"));
          }
        });
      });
    }
  }
  